import {MenuChangeEvent} from 'common/components/select/types';

export type ProjectSwitcherProps = {
  onClickCreateProject: () => void;
  onMenuChange?: (ev: MenuChangeEvent) => void;
  isCollapsedMode?: boolean;
};

export enum TrackingEvent {
  CreateDataViewClicked = `Create Data View Clicked`,
  CreateProjectClicked = `Create Project Clicked`,
  ProjectSelected = `Project Selected`,
  WorkspaceSelected = `Workspace Selected`,
  BackToProjectsClicked = `Back To Projects Clicked`,
}
